import React, { useReducer, ReactNode, useMemo } from 'react';
import { createContext } from '../selectableContext';
import ManagementActions from './actions';
import ManagementReducer from './reducer';

export const ManagementContext = createContext({});
export const initialManagementState = {
  accountTypes: [],
  accountTypesLoaded: false,
  adminTelemetryEvents: [],
  approvalItems: [],
  approvalItemsLoaded: false,
  numApprovalItemsShown: 5,
  loaded: false,
  moderators: [],
  moderatorsLoaded: false,
  supermods: [],
  supermodsLoaded: false,
  bannedUsers: [],
  bannedUsersLoaded: false,
  numModeratorsShown: 5,
  numSupermodsShown: 5,
  wealthData: [],
  wealthDataLoaded: false,
  notableUsersView: 'overview',
  subtitleTranslationProgress: {
    progress: 0,
    stage: '',
    current: 0,
    total: 0,
    error: '',
    warning: ''
  },
  subtitleMergeProgress: {
    progress: 0,
    stage: '',
    error: ''
  },
  videoFile: null,
  videoUrl: null,
  subtitles: [],
  isMergingInProgress: false,
  isTranslationInProgress: false
};

export function ManagementContextProvider({
  children
}: {
  children: ReactNode;
}) {
  const [managementState, managementDispatch] = useReducer(
    ManagementReducer,
    initialManagementState
  );
  const memoizedActions = useMemo(
    () => ManagementActions(managementDispatch),
    [managementDispatch]
  );
  const contextValue = useMemo(
    () => ({ state: managementState, actions: memoizedActions }),
    [managementState, memoizedActions]
  );
  return (
    <ManagementContext.Provider value={contextValue}>
      {children}
    </ManagementContext.Provider>
  );
}
